// Create Redux action types
export const STORE_START_END_DATE = 'STORE_START_END_DATE';


export const storeStartEndDates = (filterStartDate,filterEndDate) => ({
    type: STORE_START_END_DATE,
    startDate: filterStartDate,
    endDate: filterEndDate,
});

